import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ContactInfo } from "src/app/models/user/models";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";
import { MustMatch } from "src/app/_helper/must-match.validator";

@Component({
	selector: "app-create-account",
	templateUrl: "./create-account.component.html",
	styleUrls: ["./create-account.component.css"]
})
export class CreateAccountComponent implements OnInit {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService,
		public userDataService: USERDataService,
		public userStoreService: USERStoreService,
		public dmvStoreService: DMVStoreService,
		private formBuilder: FormBuilder,
		private cd: ChangeDetectorRef
	) {}
	public submitted = false;
	public accountForm: FormGroup;
	public errorMessage: string = "";
	public isOpenTerms = false;
	public isloading: boolean = false;
	ngOnInit() {
		let kioskEmailAddress: string = "";
		if (this.globalService.supportKioskPickup) {
			kioskEmailAddress = this.dmvStoreService.registrationsInCart
				.pickupInPerson.email;
		}
		this.accountForm = this.formBuilder.group(
			{
				emailAddress: [
					kioskEmailAddress,
					[
						Validators.required,
						Validators.pattern(
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					]
				],
				confirmEmailAddress: [
					"",
					[
						Validators.required,
						Validators.pattern(
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					]
				],
				password: [
					"",
					Validators.compose([
						Validators.required,
						Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
						this.globalService.passwordValidation()
					])
				],
				confirmPassword: [
					"",
					[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]
				],
				businessName: [
					"",
					[Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]
				],
				lastName: [""],
				collectorCounty: ["", Validators.required],
				termsAndConditions: [false, Validators.required]
			},
			{
				validator: [
					MustMatch("password", "confirmPassword"),
					MustMatch("emailAddress", "confirmEmailAddress", true)
				]
			}
		);
		if (this.userStoreService.accountCreateFormData) {
			this.accountForm = this.userStoreService.accountCreateFormData;
		}
	}
	public get f() {
		return this.accountForm.controls;
	}

	public openTerms() {
		this.isOpenTerms = true;
	}
	public closePopupTerms() {
		this.isOpenTerms = false;
	}
	public cancel() {
		this.back();
	}
	public back() {
		this.userStoreService.accountCreateFormData = null;
		if (this.userStoreService.accountfromLogin) {
			this.router.navigate(["log-in"], { skipLocationChange: true });
		} else {
			const url = this.globalService.userActionCallFrom.replace("/", "");
			this.router.navigate([url], { skipLocationChange: true });
		}
	}
	public continue() {
		this.errorMessage = "";
		this.submitted = true;
		if (this.accountForm.invalid || !this.f.termsAndConditions.value) {
			this.errorMessage = "Please correct fields in error.";
			console.log("accountForm.invalid");
			return;
		}
		this.isloading = true;
		this.createUser();
	}
	public createUser() {
		const request: ContactInfo = Object.assign({});
		request.agencyID = this.accountForm.controls.collectorCounty.value;
		request.emailAddress = this.accountForm.controls.emailAddress.value;
		request.firstName = this.accountForm.controls.businessName.value;
		request.lastName = this.accountForm.controls.lastName.value;
		request.password = this.accountForm.controls.password.value;
		request.authTypeID = 1;

		this.userDataService
			.createAccountResponse(this.dmvStoreService.sessionGUID, request)
			.subscribe(
				response => {
					AppUtil.log("Create Account createUser() ==>", response);

					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.userStoreService.accountCreateFormData = null;
							this.userStoreService.outComeText = response.OutcomeText;

							this.userStoreService.setUserProfile(response.userProfile);
							this.router.navigate(["account-created"], {
								skipLocationChange: true
							});
						} else {
							this.errorMessage = response.OutcomeText;
							window.scrollTo(0, 0);
						}
						this.cd.markForCheck();
					}
				},
				error => {
					AppUtil.log("Create Account createUser() ==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}

	public faq() {
		this.userStoreService.accountCreateFormData = this.accountForm;
		this.router.navigate(["account-faqs"], { skipLocationChange: true });
	}
}
